import React from 'react'
import { styled } from '@mui/material'
import { IndeterminateCheckbox } from '../IndeterminateCheckbox'
import { AMSIcon } from '@edge/spark/ui-assets'
import type { Column, Row, UseRowSelectInstanceProps, UseRowSelectRowProps } from 'react-table'
import type { SearchVehicle } from '../../generated/graphql'

const StyledAMSIcon = styled(AMSIcon)`
    color: #757575;
    fill: currentColor;
    font-size: 24px;
    padding: 0px 9px;
`

export const amsSelectionColumn: Column<SearchVehicle> = {
    id: 'selection',
    Header: ({ getToggleAllRowsSelectedProps }: UseRowSelectInstanceProps<any>) => (
        <div>
            <IndeterminateCheckbox style={{ padding: '0px 9px' }} disabled {...getToggleAllRowsSelectedProps()} />
        </div>
    ),
    Cell: ({ row }: { row: Row<SearchVehicle> & UseRowSelectRowProps<SearchVehicle> }) =>
        row.original.stockNumber && +row.original.stockNumber > 0 ? (
            <StyledAMSIcon />
        ) : (
            <IndeterminateCheckbox style={{ padding: '0px 9px' }} {...row.getToggleRowSelectedProps()} />
        ),
}
